

window.WP_Grid_Builder && WP_Grid_Builder.on( 'init', function( wpgb ) {

    // console.dir( wpgb ); // Holds all instances.

    // Where 'instanceName' can be: facets, grid, carousel, lightbox.
    // Where 'eventName' is the event name attached to an instance.
	wpgb.facets.on( 'render', function( holder ) {

		console.log( 'render', holder, this.facet );

	} );

} );